import { Component } from "react";
import { withRouter, Switch, Route } from "react-router-dom";
// CSS

// Library
import Cookies from "js-cookie";
import { vcMessenger } from "../react-lib/compat/vc-websocket";
import Fingerprint2 from "fingerprintjs2";
import {
  IntlProvider,
  // createIntlCache,
  // createIntl,
} from "react-intl";

// Frameworks
import SetProp from "react-lib/frameworks/SetProp";

// IsHealth
import { createNotificationSubscription } from "../react-lib/apps/IsHealth/Common/push-notifications";
// import { flattenMessages } from "../react-lib/localization/IsHealth/util";
// import messages from "../react-lib/localization/IsHealth/messages";
import thMessage from "react-lib/localization/bplusClinic/th.json";
import enMessage from "react-lib/localization/bplusClinic/en.json";

// Controller
import MobMedicationController from "./MobMedicationController";

// Interface
import * as MobMedicationI from "./MobMedicationInterface";

// UI
import MainMedication from "./medication/MainMedication";
import AllergyDetail from "../bplus-lib/history/AllergyDetail";

import CONFIG from "../config/config";

// Style
import "../css/MobAppointment.scss";

import HeaderBar from "../bplus-lib/medication/HeaderBar";
import SelectHospital from "./appointment/SelectHospital";

// Constant
const LANGUAGE: {
  TH: "th-TH";
  EN_US: "en-US";
} = {
  TH: "th-TH",
  EN_US: "en-US",
};

const THEME = {
  DEFAULT: "",
  PENTA: "penta",
  PENGUIN: "penguin",
};

class MobMedication extends Component<any, MobMedicationI.State> {
  controller: MobMedicationController;

  constructor(props: any) {
    super(props);
    this.state = { ...MobMedicationI.StateInitial };
    this.controller = new MobMedicationController(
      () => {
        return this.state;
      },
      (state: MobMedicationI.State, callback: any) => {
        this.setState(state, callback);
      },
      window
    );

    // @ts-ignore
    globalThis.setState = this.setState.bind(this);

    this.controller.setProp = SetProp(this, "");
    this.controller.cookies = Cookies;
  }

  componentDidMount = () => {
    this.controller.handleEvent({ message: "DidMount", params: {} });

    // Get login info from Mobile App
    if (!this.state.loggedin) {
      // globalThis.mobile.getLoginInfo();
      this.controller.handleEvent({
        message: "GetLoginInfo",
        params: {},
      });
    }

    const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");

    if (prefersDarkScheme.matches) {
      document.documentElement.setAttribute("color-scheme", "light");
    } else {
      document.documentElement.setAttribute("color-scheme", "light");
    }

    if (CONFIG.COMPANY === "BDMS") {
      document.documentElement.setAttribute("data-theme", THEME.PENGUIN);
    } else {
      document.documentElement.setAttribute("data-theme", THEME.PENTA);
    }

    document.querySelector("body")?.classList.add("body-mob-appointment");

    const userProfile = window.mobile?.getUser?.();
    const user = JSON.parse(userProfile || "{}");

    if (user?.device_type === "android") {
      requestIdleCallback(() => {
        console.log("get fingerprint on requestIdleCallback");
        this.getFingerPrint();
        this.getApiToken(this.props);
      });
    } else {
      console.log("fallback with timeout");
      setTimeout(() => {
        this.getFingerPrint();
        this.getApiToken(this.props);
      }, 500);
    }
  };

  componentDidUpdate(prevProps: any, prevState: any) {
    if (
      prevState.apiToken !== this.state.apiToken &&
      prevState.userId !== this.state.userId &&
      this.state.userId &&
      this.state.apiToken
    ) {
      Cookies.set("apiToken", this.state.apiToken || "", { path: "/" });
      Cookies.set("userId", this.state.userId.toString() || "", { path: "/" });
      this.controller.handleEvent({
        message: "HandleGetUserWithPatientDetail",
        params: {},
      });
    }
  }

  getFingerPrint = () => {
    var options = {};
    Fingerprint2.getPromise(options).then((components) => {
      // components is array of {key: 'foo', value: 'component value'}
      var values = components.map(function (component) {
        return component.value;
      });
      var device_id = Fingerprint2.x64hash128(values.join(""), 31);
      this.setState({ device_id: device_id });
      console.log("MP Fingerprint id:", device_id);
      // Get subscription endpoint object
      createNotificationSubscription()
        .then((subscription) => {
          this.setState({ subscription: subscription });

          console.log("MP Success get notification subscription..");
          console.log(subscription);
        })
        .catch((err) => {
          console.log("MP error getSubScriptionObejct");
          console.error(
            "Couldn't create the notification subscription",
            err,
            "name:",
            err.name,
            "message:",
            err.message,
            "code:",
            err.code
          );
        });
    });
  };

  getApiToken = async (props: any) => {
    console.log(" getApiToken called");
    var apiToken;
    var userId;

    if (window.mobile?.getUser) {
      let userProfile = window.mobile.getUser();
      const user = JSON.parse(userProfile || "{}");
      console.log("get apiToken from ", user?.device_type, user);

      apiToken = user?.token || "";
      userId = user?.profile?.userId || "";
      Cookies.set("apiToken", apiToken, { path: "/" });
      Cookies.set("userId", userId, { path: "/" });
      // this.getPatientDetail({ token: user.token })
      this.setWebsocket({ apiToken: apiToken });
      this.setState({ apiToken: apiToken, userId: userId });
    } else {
      console.log("get apiToken from browser (cookies)");
      if (props) {
        apiToken = Cookies.get("apiToken");
        userId = Cookies.get("userId");

        this.setState({ apiToken: apiToken, userId: userId });
        console.log(" apiToken", apiToken);
        console.log(" userId", userId);
      }
    }
  };

  setWebsocket = ({ apiToken }: any = {}) => {
    console.log("setWebsocket");
    console.log(apiToken, "apiToken");
    console.log(CONFIG.WS_HOST, "CONFIG.WS_HOST");
    vcMessenger.connect(
      "MSG",
      {
        token: apiToken,
      },
      CONFIG.WS_HOST
    );
  };

  handleGoBackAllergy = () => {
    this.props.history.goBack();

    this.controller.handleEvent({
      message: "HandleChangeAllergyTab",
      params: { reset: true },
    });
  };

  render = () => {
    console.log(this.state);
    return (
      <IntlProvider
        locale="th-TH"
        // messages={flattenMessages(messages["en-US"])}
        // messages={flattenMessages(
        //   messages[this.state.language || LANGUAGE.EN_US]
        // )}
        messages={this.state.language?.includes("TH") ? thMessage : enMessage}
      >
        <div style={{ background: "white", height: "100vh" }}>
          <Switch>
            <Route
              path="/Select-Hospital"
              render={(props) => {
                return (
                  <div>
                    <SelectHospital
                      onEvent={this.controller.handleEvent}
                      hospitalList={this.state.hospitalList}
                      onClose={() => this.props.history.goBack()}
                      firstLoadingHospital={!this.state.loadingHospital}
                      history={this.props.history}
                      selectedHospital={this.state.selectedHospital}
                    />
                  </div>
                );
              }}
            />
            <Route
              path="/Allergy-Card"
              render={(props) => {
                return (
                  <div>
                    <HeaderBar
                      onEvent={this.controller.handleEvent}
                      hospitalList={this.state.hospitalList}
                      selectedHospital={this.state.selectedHospital}
                      setTitle={"Allergy and warning"}
                      currentMob={"MobHistory"}
                      buttonLeftback={true}
                      hiddenLeft={true}
                      hiddenRight={true}
                      // callback
                      onGoBack={this.handleGoBackAllergy}
                    />
                    <AllergyDetail
                      // function
                      onEvent={this.controller.handleEvent}
                      // data
                      history={this.props.history}
                      hospitalList={this.state.hospitalList}
                      selectedHospital={this.state.selectedHospital}
                      medAllergyList={this.state.medAllergyList}
                      firstLoadingAllergy={this.state.firstLoadingAllergy}
                      medAllergyGroup={this.state.medAllergyGroup}
                      allergyTab={this.state.allergyTab}
                    />
                  </div>
                );
              }}
            />
            <Route
              path="/"
              render={(props) => {
                return (
                  <div>
                    <HeaderBar
                      onEvent={this.controller.handleEvent}
                      hospitalList={this.state.hospitalList}
                      selectedHospital={this.state.selectedHospital}
                      history={this.props.history}
                      currentMob={"MobPHR"}
                    />

                    <MainMedication
                      onEvent={this.controller.handleEvent}
                      medicationItem={this.state.medicationItem}
                      loadingMedication={this.state.loadingMedication}
                      loadingHospital={this.state.loadingHospital}
                      firstLoadingAllergy={this.state.firstLoadingAllergy}
                      selectedHospital={this.state.selectedHospital}
                      getReminderData={this.state.getReminderData}
                      medAllergyList={this.state.medAllergyList}
                      history={this.props.history}
                      language={this.state.language}
                      hospitalList={this.state.hospitalList}
                      currentMedication={this.state.currentMedication}
                      loadingUpdateCurrent={this.state.loadingUpdateCurrent}
                      isCurrentMed={CONFIG.ENABLE_CURRENT_MEDICATION}
                    />
                  </div>
                );
              }}
            />
          </Switch>
        </div>
      </IntlProvider>
    );
  };
}

export default withRouter(MobMedication);
